import React, { useContext, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';

import { PreferLocationContext } from '../../../../services/prefer-location/prefer-location.context';
import { ProfileContext } from '../../../../services/profile/profile.context';


export const UserPreferLocation = () => {
  const { user } = useContext(ProfileContext)

  const map = useMap();
  const { preferLocation, getUserPreferLocation, fetchUserLocation } = useContext(PreferLocationContext);

  useEffect(() => {
    user && getUserPreferLocation(map);
    fetchUserLocation && getUserPreferLocation(map);
  }, [user, map, fetchUserLocation]);

  return (
    <>
      {preferLocation && preferLocation !== null && (
        <Marker
          position={[preferLocation.lat, preferLocation.lng]}
          icon={L.icon({
            iconUrl: `/icons/marker_${preferLocation.type}_icon.webp`,
            iconSize: [31, 46],
            iconAnchor: [15.5, 42],
            popupAnchor: [0, -45],
          })}
        >
          <Popup>
            <Typography variant='subtitle1'>{preferLocation.name}</Typography>
            <Typography variant='caption'>{preferLocation.address}</Typography>
          </Popup>
        </Marker>
      )}
    </>
  );
};
